import { SearchSchemaInput } from '@tanstack/react-router'

import { z } from '@authy/lib-common/utils/zod'

export const createValidateSearch =
    <TShape extends z.ZodRawShape, TSchema extends z.ZodObject<TShape>>(schema: TSchema) =>
    (search: z.input<TSchema> & SearchSchemaInput): z.output<TSchema> =>
        schema.parse(search)
